"use client";

import Image from "next/image";
import styles from "./page.module.css";
import LocationCard from "./components/location-card";
import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { LocationsResponse } from "./types";
import { useLocationsStore } from "./locations-store";
import { Pagination } from "./components/pagination";
import { useLocale } from "next-intl";
import { useUserAuthDataContext } from "@/global-context/user-auth-context";

export default function AdminLocationsPageLayout({
  locationsData,
  locale,
}: {
  locationsData: LocationsResponse;
  locale: string;
}) {
  const [previewImage, setPreviewImage] = useState("");
  const [isSquare, setIsSquare] = useState(false);
  const [isWide, setIsWide] = useState(false);
  const [isLarge, setIsLarge] = useState(false);
  const {
    locations,
    initStore,
    current_page_number: page_number,
    count,
    getPage,
    setFetchWithPhotos,
  } = useLocationsStore();
  const { userData } = useUserAuthDataContext();
  useEffect(() => {
    initStore(locationsData);
  }, [locationsData]);
  return (
    <main className={styles.main}>
      <h2 className={styles.title}>Manage Global Locations</h2>
      <div className={styles.settingWrapper}>
        <p>Select which locations to get based on photos:</p>
        <button
          onClick={async (e) => {
            e.preventDefault();
            await setFetchWithPhotos(
              "",
              page_number,
              userData.sessionId,
              locale
            );
          }}
        >
          Any
        </button>
        <button
          onClick={async (e) => {
            e.preventDefault();
            await setFetchWithPhotos(
              "false",
              page_number,
              userData.sessionId,
              locale
            );
          }}
        >
          No Photo
        </button>
        <button
          onClick={async (e) => {
            e.preventDefault();
            await setFetchWithPhotos(
              "true",
              page_number,
              userData.sessionId,
              locale
            );
          }}
        >
          With Photo
        </button>
      </div>
      <ul className={styles.locationsList}>
        {locations.map((location, _) => {
          return (
            <li className={styles.locationItem} key={location.slug}>
              <LocationCard
                location={location}
                onPreviewClick={() => {
                  setPreviewImage(location.photo_url);
                }}
                idToken={userData.sessionId}
              />
            </li>
          );
        })}
      </ul>
      {previewImage !== "" && (
        <div
          className={`${styles.preview} ${isLarge && styles.isLarge} ${
            isSquare && styles.isSquare
          } ${isWide && styles.isWide}`}
        >
          <button
            onClick={(e) => {
              e.preventDefault();
              setPreviewImage("");
            }}
            className={styles.closeButton}
          >
            <MdClose />
          </button>
          <Image
            className={styles.image}
            src={previewImage}
            width={1600}
            height={900}
            alt="Preview image."
            priority={true}
          />
          <div className={styles.buttonsWrapper}>
            <button
              onClick={(e) => {
                e.preventDefault();
                setIsLarge(false);
                setIsWide(false);
                setIsSquare(true);
              }}
              className={styles.viewButton}
            >
              Square
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setIsLarge(false);
                setIsSquare(false);
                setIsWide(true);
              }}
              className={styles.viewButton}
            >
              Wide
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                setIsWide(false);
                setIsSquare(false);
                setIsLarge(true);
              }}
              className={styles.viewButton}
            >
              Large
            </button>
          </div>
        </div>
      )}
      <Pagination
        total={count}
        pageSize={24}
        currentPage={page_number}
        onPageChange={async (pageNumber) => {
          await getPage(pageNumber, userData.sessionId, locale);
        }}
      />
    </main>
  );
}
